import React, { useState } from 'react';
import { Button, Container, Navbar } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { TEXT_CONSTANT, IMAGE_CONSTANT } from '../../../constants/app';
import { withRouter } from 'react-router-dom';
import { APP_ROUTES } from '../../../route';
import HamburgerMenu from '../../../components/HamburgerMenu';
import useWindowWidth from '../../../hooks/useWindowWidth';
import { getDisplayType } from '../../../utils/helpers';
import { ShouldRender } from '../../../ui-core/ShouldRender';
// import { getItem } from '../../../utils/cache';
import { useSelector } from 'react-redux';
import OfflineCartOffCanvas from '../../../components/OfflineCartOffCanvas';

const Header = props => {
  const { OfflineCart } = useSelector(state => state.checkout);
  const [isOpen, setIsOpen] = useState(false);
  const handleRedirection = page => {
    if (page === 'jen') {
      props.history.push(APP_ROUTES.HOME);
    } else if (page === 'podcast') {
      props.history.push(APP_ROUTES.PODCASTS);
    } else if (page === 'gifts') {
      props.history.push(APP_ROUTES.GIFTS);
    } else if (page === 'courses') {
      props.history.push(APP_ROUTES.COURSES);
    } else {
      props.history.push(APP_ROUTES.BLOGS);
    }
  };
  const displayType = getDisplayType(useWindowWidth());
  const isMobileScreen = displayType === 'mobile';
  const handleClick = () => {
    setIsOpen(!isOpen);
  };
  return (
    <>
      <Navbar
        id="header-section"
        bg=""
        expand="lg"
        className="bg-white jen-navbar"
      >
        <Container fluid>
          <div className="d-flex justify-content-between position-relative new-home-header px-lg-5 align-items-center w-100">
            <div className="d-flex logo-header mb-0">
              {isMobileScreen && (
                <HamburgerMenu
                  blogClass={props.blogClass}
                  podcastClass={props.podcastClass}
                  giftClass={props.giftClass}
                  challengeClass={props.challengeClass}
                  // onFreeTrialClick={() => {
                  //   props.onClick(
                  //     TEXT_CONSTANT.GET_STARTED_FOR_FREE,
                  //     'isSignup',
                  //     'navigation header',
                  //   );
                  // }}
                  onFreeTrialClick={() =>
                    props.history.push(APP_ROUTES.SIGNUP_ONBOARDING)
                  }
                  onLoginClick={() => {
                    props.onClick('LOGIN', 'isLogin', 'navigation header');
                  }}
                />
              )}
              <h2
                className="logo-text mb-0"
                onClick={() => handleRedirection('jen')}
              >
                Jen
              </h2>
              {/* <div> */}
              {!isMobileScreen && (
                <>
                  <span
                    className={`nav-item ${props.podcastClass}`}
                    onClick={() => handleRedirection('podcast')}
                  >
                    <img alt="PodcastIcon" src={IMAGE_CONSTANT.MicMenu} />
                    Podcasts
                  </span>
                  <span
                    className={`nav-item ${props.blogClass}`}
                    onClick={() => handleRedirection('blog')}
                  >
                    <img alt="BlogIcon" src={IMAGE_CONSTANT.NoteMenu} />
                    Blog
                  </span>
                  <span
                    className={`nav-item ${props.challengeClass}`}
                    onClick={() => handleRedirection('courses')}
                  >
                    <img alt="CourseIcon" src={IMAGE_CONSTANT.challengeImg} />
                    Courses
                  </span>
                  <span
                    className={`nav-item ${props.giftClass}`}
                    onClick={() => handleRedirection('gifts')}
                  >
                    <img alt="GiftIcon" src={IMAGE_CONSTANT.GiftMenu} />
                    Gift Health
                  </span>
                </>
              )}
              {/* </div> */}
            </div>
            <div className="d-flex align-items-center">
              {!isMobileScreen && (
                <button
                  className="join"
                  // onClick={() =>
                  //   props.onClick(
                  //     TEXT_CONSTANT.GET_STARTED_FOR_FREE,
                  //     'isSignup',
                  //     'navigation header',
                  //   )
                  // }
                  onClick={() => {
                    if (props.freeTrialPage) {
                      props.onClick(
                        TEXT_CONSTANT.GET_STARTED_FOR_FREE,
                        'isSignup',
                        'Start my free week',
                      );
                    } else {
                      props.history.push(APP_ROUTES.SIGNUP_ONBOARDING);
                    }
                  }}
                >
                  {props.freeTrialPage
                    ? TEXT_CONSTANT.START_FREE_TRAIL
                    : TEXT_CONSTANT.GET_STARTED_FOR_FREE}
                </button>
              )}
              {!props.freeTrialPage && (
                <button
                  className="join"
                  onClick={() =>
                    props.onClick('LOGIN', 'isLogin', 'navigation header')
                  }
                >
                  {TEXT_CONSTANT.LOGIN}
                </button>
              )}
              {OfflineCart?.length ? (
                <Button
                  className="p-2 cart-icon d-flex flex-column justify-content-between align-items-center"
                  onClick={handleClick}
                  variant="light"
                >
                  <img alt="cart" src={IMAGE_CONSTANT.shoppingCartIcon} />
                  <ShouldRender check={OfflineCart?.length > 0}>
                    <span className="items-count">{OfflineCart?.length}</span>
                  </ShouldRender>
                </Button>
              ) : null}
            </div>
          </div>
        </Container>
      </Navbar>
      <OfflineCartOffCanvas
        setIsOpen={setIsOpen}
        isOpen={isOpen}
        OfflineCart={OfflineCart}
        props={props}
      />
    </>
  );
};

Header.propTypes = {
  history: PropTypes.object,
  onClick: PropTypes.func.isRequired,
  freeTrialPage: PropTypes.bool,
  podcastClass: PropTypes.string,
  blogClass: PropTypes.string,
  giftClass: PropTypes.string,
  challengeClass: PropTypes.string,
};

export default withRouter(Header);
